export const clefNames = [
  'treble',
  'soprano',
  'mezzo-soprano',
  'alto',
  'tenor',
  'baritone',
  'bass',
  'percussion',
] as const;

export type ClefName = typeof clefNames[number];

export const pitchClefNames = [
  'treble',
  'soprano',
  'mezzo-soprano',
  'alto',
  'tenor',
  'baritone',
  'bass',
] as const;

export type PitchClefName = typeof pitchClefNames[number];

export function isClefName(clefName: any): clefName is ClefName {
  if (typeof clefName !== 'string') return false;
  return clefNames.includes(clefName as ClefName);
}

/**
 * The number of the line where middle-C is located in this clef.
 */
export const clefsCLines: Record<ClefName, number> = {
  treble: 0,
  soprano: 1,
  'mezzo-soprano': 2,
  alto: 3,
  tenor: 4,
  baritone: 5,
  bass: 6,
  percussion: 0,
};

/**
 * Dictionary of vexflow clef names for each uTheory clef name.
 */
export const clefNameToVexClefName: Record<ClefName, string> = {
  treble: 'treble',
  soprano: 'soprano',
  'mezzo-soprano': 'mezzo-soprano',
  alto: 'alto',
  tenor: 'tenor',
  baritone: 'baritone-f',
  bass: 'bass',
  percussion: 'percussion',
};
